// extracted by mini-css-extract-plugin
export default {"successModalBody":"SuccessModal_successModalBody__Oen72"};